import React from 'react';
import Icon from '../../../components/AppIcon';

const AnonymityAssurance = () => {
  const features = [
    {
      icon: 'Shield',
      text: 'Posts are profile-less and anonymous'
    },
    {
      icon: 'Lock',
      text: 'No usernames or author pages'
    },
    {
      icon: 'Users',
      text: 'Community helps protect privacy'
    }
  ];

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 md:p-5 lg:p-6 mb-6 md:mb-7 lg:mb-8">
      <div className="flex items-start gap-3 mb-4">
        <div className="flex-shrink-0 mt-0.5">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg">
            <Icon name="Heart" size={24} color="var(--color-primary)" strokeWidth={2} />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-2">
            Share Your Story Safely
          </h2>
          <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
            This is your safe space to express emotions and share struggles. Please write anonymously to protect your privacy.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        {features?.map((feature, index) => (
          <div
            key={index}
            className="flex items-center gap-3 p-3 bg-background rounded-lg border border-border"
          >
            <Icon
              name={feature?.icon}
              size={18}
              color="var(--color-primary)"
              strokeWidth={2}
            />
            <span className="text-xs md:text-sm text-foreground">
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnonymityAssurance;